
import { defineComponent } from 'vue';
import { IExtension, IExtensionRelease } from '@/types/models';
import utils from '@/utils';
import api from '@/api/admin/extensions';
import TableView from './components/extensions/TableView.vue';
import FormState from './components/extensions/FormState.vue';
import FormTags from './components/extensions/FormTags.vue';

interface IState {
  state: string;
  extensions: IExtension[];
  allTagNames: string[];
  allCount: number;
  pendingCount: number;
  publishedCount: number;
  rejectedCount: number;
  isTableView: boolean;
  extension: IExtension;
  releases: IExtensionRelease[];
  isFormState: boolean;
  isFormTags: boolean;
}

export default defineComponent({
  components: { TableView, FormState, FormTags },
  data() {
    return {
      state: 'All',
      extensions: [],
      allTagNames: [],
      allCount: 0,
      pendingCount: 0,
      publishedCount: 0,
      rejectedCount: 0,
      isTableView: false,
      extension: {} as IExtension,
      releases: [],
      isFormState: false,
      isFormTags: false,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(
        {
          state: this.state,
        },
        (res) => {
          this.extensions = res.extensions;
          if (this.state === 'All') {
            this.allTagNames = res.allTagNames;
            this.allCount = res.allCount;
            this.pendingCount = res.pendingCount;
            this.publishedCount = res.publishedCount;
            this.rejectedCount = res.rejectedCount;
          }
        },
      );
    },

    apiGetReleases(extension: IExtension) {
      api.getReleases(
        {
          userName: extension.userName,
          name: extension.name,
        },
        (res) => {
          this.releases = res.releases;
          this.isTableView = true;
          this.extension = extension;
        },
      );
    },

    apiDelete(extension: IExtension) {
      api.delete(
        {
          userName: extension.userName,
          name: extension.name,
        },
        (res) => {
          if (!res) return;
          this.state = 'All';
          utils.success('插件删除成功！');
          this.apiGet();
        },
      );
    },

    getResourceState(extension: IExtension): string {
      return utils.getResourceState(extension.state, extension.isFeatured);
    },

    getUrl(relatedUrl: string) {
      return `https://sscms.com/extensions/${relatedUrl}`;
    },

    getDownloadUrl(extension: IExtension) {
      return `https://dl.sscms.com/extensions/${extension.userName}/${extension.name}/${extension.userName}.${extension.name}.${extension.latestVersion}.zip`;
    },

    getIconUrl(extension: IExtension) {
      if (extension.iconUrl) {
        return `https://storage.sscms.com/${utils.trim(extension.iconUrl, '/')}`;
      }
      return '';
    },

    btnViewClick(extension: IExtension) {
      this.apiGetReleases(extension);
    },

    btnNavClick() {
      this.apiGet();
    },

    btnDeleteClick(extension: IExtension) {
      utils.alertDelete(
        {
          title: '删除插件',
          text: `此操作将删除插件 ${extension.userName}.${extension.name}，确定吗？`,
          button: '确认删除',
        },
        () => {
          this.apiDelete(extension);
        },
      );
    },

    btnStateClick(extension: IExtension) {
      this.extension = extension;
      this.isFormState = true;
    },

    btnTagsClick(extension: IExtension) {
      this.extension = extension;
      this.isFormTags = true;
    },

    updateExtension(value: IExtension) {
      const index = this.extensions.findIndex((x) => x.id === value.id);
      if (index !== -1) {
        this.extensions[index] = value;
      }
      this.isFormState = false;
      this.isFormTags = false;
    },
  },
  mounted() {
    this.apiGet();
  },
});
